// Lot 615 — vignettes le long de la piste de découpe : N images réparties sur la durée, extraites d'un seul
// élément <video> (seeks successifs) → data URLs JPEG légères. Annulable (cancelled()) ; jamais bloquant.
export const extractVideoThumbs = (src, count = 10, { duration = 0, width = 96, cancelled = () => false } = {}) =>
  new Promise((resolve) => {
    if (!src || count < 1) { resolve([]); return; }
    const video = document.createElement("video");
    video.src = src;
    video.muted = true;
    video.playsInline = true;
    video.preload = "auto";
    video.crossOrigin = "anonymous";
    const out = [];
    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      try { video.pause(); video.removeAttribute("src"); video.load(); } catch { /* noop */ }
      resolve(out);
    };
    const timer = setTimeout(finish, 15000);
    const canvas = document.createElement("canvas");
    const draw = () => {
      const w = video.videoWidth || 160, h = video.videoHeight || 90;
      const scale = width / w;
      canvas.width = Math.max(1, Math.round(w * scale));
      canvas.height = Math.max(1, Math.round(h * scale));
      try {
        canvas.getContext("2d").drawImage(video, 0, 0, canvas.width, canvas.height);
        return canvas.toDataURL("image/jpeg", 0.6);
      } catch { return null; }
    };
    video.onloadedmetadata = () => {
      const dur = (isFinite(video.duration) && video.duration > 0) ? video.duration : duration;
      if (!dur) { clearTimeout(timer); finish(); return; }
      let i = 0;
      const next = () => {
        if (cancelled() || i >= count) { clearTimeout(timer); finish(); return; }
        const t = Math.min(dur - 0.05, ((i + 0.5) / count) * dur);
        i += 1;
        const onSeeked = () => {
          video.removeEventListener("seeked", onSeeked);
          const url = draw();
          if (url) out.push(url);
          setTimeout(next, 0);
        };
        video.addEventListener("seeked", onSeeked);
        try { video.currentTime = Math.max(0, t); } catch { onSeeked(); }
      };
      next();
    };
    video.onerror = () => { clearTimeout(timer); finish(); };
  });
